// The tap zones of an illustrated page.
//
// A book page may carry areas a reader can tap: the duck quacks, the door
// leads to another page. They are authored in the editor as a rect in the
// page's design space plus a sound and/or a page to jump to, and the Unity
// player acts on them exactly this way (aldoo-books
// book_player/features/playback.lua).
//
// The zones are invisible — the picture is the interface — but they answer to
// a pointer and to the keyboard, so a page's actions are reachable without a
// mouse.
import React, { useEffect, useRef } from "react"
import { triggerRects } from "./layout"
import useT from "../Storefront/hooks/useT"

export default function TriggerAreas({ page, viewport, engine, pageCount }) {
  const t = useT()
  const soundRef = useRef(null)
  const rects = triggerRects(viewport, page)

  // one element plays every zone's sound: tapping a second zone interrupts the
  // first, as tapping again in the app does
  useEffect(() => {
    const sound = new Audio()
    sound.preload = "none"
    soundRef.current = sound
    return () => {
      sound.pause()
      soundRef.current = null
    }
  }, [])

  if (!rects.length) return null

  const fire = (rect) => {
    const sound = soundRef.current
    if (rect.audio && sound) {
      sound.src = rect.audio
      sound.currentTime = 0
      sound.play().catch(() => {})
    }
    // the pages are numbered from one in the editor, from zero in the engine
    if (rect.gotoPage > 0 && rect.gotoPage <= pageCount) engine.goToPage(rect.gotoPage - 1, { at: 0 })
  }

  return (
    <div className="absolute inset-0 z-10" data-testid="player-triggers">
      {rects.map((rect) => (
        <button
          key={rect.index}
          type="button"
          onClick={() => fire(rect)}
          aria-label={rect.gotoPage > 0 ? t`Go to page` : t`Play sound`}
          data-testid="player-trigger"
          className="absolute rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
          style={{ left: rect.left, top: rect.top, width: rect.width, height: rect.height }}
        />
      ))}
    </div>
  )
}
